import * as React from 'react';

import { Dropdown, Menu } from 'antd';
import { DropdownPlacement } from 'farmhub-ui-core';
import { Link } from 'react-router-dom';

import { CMenuItem, Wrapper, CSubMenu } from './styles';

interface IDataItem {
  name: string;
  link?: any; // TODO: research type of link
  action?: () => void;
  key: string;
  disabled?: boolean;
  icon: any;
  children?: any;
}

interface Props {
  data: Array<IDataItem>;
  component: any;
  visible?: boolean;
  placement?: DropdownPlacement;
  onChangeVisible?: () => void;
}

const ExtendedAction = ({
  data,
  component,
  visible,
  onChangeVisible,
  placement = DropdownPlacement.BottomLeft,
}: Props): JSX.Element => {
  const menu = () => (
    <Menu>
      {data.map((item: any) => {
        if (item.link) {
          return (
            <Link key={item.key} to={item.link}>
              <CMenuItem disabled={item.disabled}>{item.name}</CMenuItem>
            </Link>
          );
        }

        if (item?.children) {
          return (
            <CSubMenu
              key={item.key}
              disabled={item?.disabled ?? false}
              icon={item.icon}
              title={item.name}
            >
              {item?.children.map((menuChild: any) => (
                <CMenuItem
                  key={`${item.key}-${menuChild.key}`}
                  disabled={menuChild?.disabled ?? false}
                  icon={menuChild?.icon}
                  onClick={menuChild.action}
                >
                  {menuChild?.tooltip}
                </CMenuItem>
              ))}
            </CSubMenu>
          );
        }

        return (
          <CMenuItem
            key={item.key}
            disabled={item?.disabled ?? false}
            icon={item.icon}
            onClick={item.action}
          >
            {item.name}
          </CMenuItem>
        );
      })}
    </Menu>
  );

  return (
    <Wrapper onClick={(e: any) => e.stopPropagation()}>
      <Dropdown overlay={menu()} placement={placement} trigger={['click']}>
        {component}
      </Dropdown>
    </Wrapper>
  );
};

export default ExtendedAction;
